import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../variants.jsx";

const About = () => {
	return (
		<section className='w-full pt-10 xl:pt-20 px-5'>
			<div>
				<motion.h2
					variants={fadeIn('down')}
					initial='hidden'
					whileInView={'show'}
					viewport={{ once: true, amount: 0.4 }}
					className='text-3xl font-bold text-white text-left px-2'>About</motion.h2>
				<div className='flex flex-col xl:flex-row gap-y-10 pt-3'>
					{/* First section with responsive layout */}
					<motion.div
						variants={fadeIn('right')}
						initial='hidden'
						whileInView={'show'}
						viewport={{ once: true, amount: 0.4 }}
						className='flex-1 w-full flex justify-center'
					>
						<div className='flex flex-col text-gray-300 sm:text-left px-2'>
							<p>
								I'm a 24-year-old software developer based in <a href='https://en.wikipedia.org/wiki/Tirana' target='_blank' className='cursor-pointer font-semibold italic hover:text-red-700 transition-all duration-500'> Tirana, Albania</a>,
								with professional experience in <span className='cursor-pointer font-semibold italic hover:text-blue-400 transition-all duration-500'>JavaScript</span>,
								<span className='cursor-pointer font-semibold italic hover:text-blue-400 transition-all duration-500'> React.js</span>, and
								<span className='cursor-pointer font-semibold italic hover:text-blue-400 transition-all duration-500'> Node.js</span>,
								complemented by a strong background in <span className='cursor-pointer font-semibold italic hover:text-blue-400 transition-all duration-500'>SQL</span>,
								<span className='cursor-pointer font-semibold italic hover:text-blue-400 transition-all duration-500'> data analysis</span>, and
								<span className='cursor-pointer font-semibold italic hover:text-blue-400 transition-all duration-500'> business intelligence</span>.
							</p>
							<p className='pt-4'>
								A motivated and adaptable developer with a strong <span className='cursor-pointer font-semibold italic hover:text-[#ae0af2] transition-all duration-500'>problem-solving mindset </span>
								and a commitment to continuous learning and delivering reliable, high-quality solutions.
							</p>
							<p className='pt-4'>
								I received my bachelors degree in Computer Science in 2024 and during my free time, I try to catch up with family or friends, and
								learn something new by working on personal projects. I go to the gym frequently and I like to read a book every now and then.
							</p>
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	);
}

export default About;
